/**
 * Row actions that show up on hover. Where nothing can hover (a touch screen)
 * they stay visible — otherwise nobody could find them.
 */
export const REVEAL_ON_HOVER_CLS =
  "[@media(hover:hover)]:opacity-0 [@media(hover:hover)]:group-hover:opacity-100 focus:opacity-100";
